import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"min-height":"550px"} }
const _hoisted_2 = { class: "w-full space-x-2 flex justify-end" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { ClientResource } from '@shared/resources/client';
import { useI18n } from 'vue-i18n';
import { useEmitter } from '@/plugins/mitt/mitt';
import { useCarModelsStore } from '@/stores/dictionary/car-models';

import { Tabs, TabData } from '@ui-kit/tabs';
import { useModalControls, BaseModal, useModalsStore, ModalConfirmation } from '@components/modals';
import ManageClientDataForm from '../partials/ManageClientDataForm.vue';
import { Table, TableServerDataManager, TableComponentParams } from '@ui-kit/table';
import { CarResource } from '@shared/resources/car';
import { CarService } from '@/services/car.service';
import Button from '@ui-kit/controls/button/Button.vue';
import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import ModalManageClientCar from './ModalManageClientCar.vue';
import { CarModelResource } from '@shared/resources/car-model';
import { Filters } from '@ui-kit/table/types';

interface Props {
  data: ClientResource;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEditClient',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ClientResource;
}

const { close } = useModalControls();
const { t } = useI18n();
const carService = new CarService();
const modalsStore = useModalsStore();
const carModelsStore = useCarModelsStore();
const emitter = useEmitter();



const tabs = computed<TabData[]>(() => {
  return [
    {
      name: 'client',
      title: t('pages.clients.tabs.client'),
    },
    {
      name: 'cars',
      title: t('pages.clients.tabs.cars'),
    },
  ]
});

const pendingCar = ref<number>();
const tableManager = new TableServerDataManager({
  path: 'cars/grid',
});

const tableParams = computed<TableComponentParams<CarResource>>(() => {
  return {
    columns: [
      {
        name: 'car_model.name',
        data: (row) => {
          const { car_model } = row;
          const { car_brand } = car_model;

          return `${car_brand.name} ${car_model.name}`;
        },
        title: t('fields.car'),
        sortable: true,
        responsiveOrder: 1,
      },
      {
        name: 'registration_plate',
        data: 'registration_plate',
        title: t('fields.registration_plate'),
        sortable: true,
      },
      {
        name: 'actions',
        title: '',
        width: 200,
        responsiveOrder: 2,
      },
    ],
  };
});

const selectedCarModel = ref<CarModelResource>();
const carModelSelectDataManager = useSelectClientDataManager({
  data: computed(() => carModelsStore.data),
  selected: selectedCarModel,
  searchBy: ['name', 'car_brand.name'],
  hideSelected: true,
});
const tableFilters = computed<Filters>(() => {
  const filters: Filters = {
    'client.id': [String(props.data.id)],
  }
  if (selectedCarModel.value) {
    filters['car_model.id'] = String(selectedCarModel.value.id);
  }
  return filters;
});
watch(tableFilters, (value) => {
  tableManager.setFilters(value);
}, {
  immediate: true,
});

function removeCar(car: CarResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.cars.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return carService.remove(car.id).send().then(() => {
          tableManager.request();
        });
      },
    },
  });
}
function addCar() {
  modalsStore.addModal({
    component: ModalManageClientCar,
    props: {
      client: props.data,
    },
  });
}
async function editCar(car_id: number) {
  pendingCar.value = car_id;
  const { data } = await carService.getById(String(car_id)).send().finally(() => {
    pendingCar.value = undefined;
  });
  modalsStore.addModal({
    component: ModalManageClientCar,
    props: {
      data,
      client: props.data,
    },
  });
}

function updateTable() {
  tableManager.request();
}
onMounted(() => {
  emitter.on('addCar', updateTable);
  emitter.on('updateCar', updateTable);
});
onBeforeUnmount(() => {
  emitter.off('addCar', updateTable);
  emitter.off('updateCar', updateTable);
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(_unref(BaseModal), {
    title: _ctx.$t('pages.clients.edit-label'),
    size: "xl",
    "no-body-padding": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Tabs), {
        tabs: _unref(tabs),
        class: "p-4"
      }, {
        "tab-client": _withCtx(() => [
          _createVNode(ManageClientDataForm, {
            data: __props.data,
            onClose: _unref(close),
            onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save', $event)))
          }, null, 8, ["data", "onClose"])
        ]),
        "tab-cars": _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Table), {
              "data-manager": _unref(tableManager),
              params: _unref(tableParams)
            }, {
              "header-left": _withCtx(() => [
                _createVNode(_unref(SingleSelect), {
                  "data-manager": _unref(carModelSelectDataManager),
                  class: "w-64",
                  modelValue: selectedCarModel.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCarModel).value = $event)),
                  "select-option-text": _ctx.$t('pages.cars.select-car-model')
                }, {
                  option: _withCtx(({option}) => [
                    _createTextVNode(_toDisplayString(option.car_brand.name) + " " + _toDisplayString(option.name), 1)
                  ]),
                  "selected-option": _withCtx(({value}) => [
                    _createTextVNode(_toDisplayString(value.car_brand.name) + " " + _toDisplayString(value.name), 1)
                  ]),
                  _: 1
                }, 8, ["data-manager", "modelValue", "select-option-text"])
              ]),
              "header-right": _withCtx(() => [
                _createVNode(Button, {
                  size: "xl",
                  "button-type": "outline",
                  onClick: addCar
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_FontAwesomeIcon, {
                      icon: "plus",
                      class: "mr-2"
                    }),
                    _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
                  ]),
                  _: 1
                })
              ]),
              "cell-actions": _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(Button, {
                    size: "sm",
                    onClick: ($event: any) => (editCar(row.id)),
                    loading: pendingCar.value === row.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FontAwesomeIcon, {
                        icon: "pen",
                        class: "mr-2"
                      }),
                      _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "loading"]),
                  _createVNode(Button, {
                    size: "sm",
                    color: "danger",
                    onClick: ($event: any) => (removeCar(row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["data-manager", "params"])
          ])
        ]),
        _: 1
      }, 8, ["tabs"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})